import { createSingletonHook } from './createSingletonHook';

export const useIsScrolled = createSingletonHook<boolean>(false, (set) => {
  const handleScroll = () => {
    set(window.scrollY > 0);
  };

  window.addEventListener('scroll', handleScroll);

  // Sync immediately (in case page is already scrolled on load)
  handleScroll();

  return () => window.removeEventListener('scroll', handleScroll);
});
